export default "__VITE_ASSET__DgFlp8Rj__"